import { IMLesson } from '../../types'
import { IM360Parser } from '../IM360Parser'
import { parseStandardsGroup } from '../standards'
import { createUnorderedList } from '../../../html_utility'

export function parseLessonSynthesis(lesson: IMLesson) {
  return [...lessonSynthesisNode(lesson), ...lessonSynthesisObservation(lesson)]
}

function lessonSynthesisNode({ lesson_synthesis }: IMLesson) {
  if (!lesson_synthesis) return []
  return [
    IM360Parser.getInstance().createActivity(
      {
        title: 'Lesson Synthesis',
        assignment: 'participation',
        assessment_grading: 'formative',
      },
      [
        IM360Parser.getInstance().createNoteNode({
          title: 'Lesson Synthesis',
          value: lesson_synthesis,
          studentFacing: false,
        }),
      ],
    ),
  ]
}

function lessonSynthesisObservation(lesson: IMLesson) {
  const observation = lesson.assessments.find(
    ({ type }) => type === 'Observation',
  )
  if (!observation?.ancillary_content.look_fors?.length) return []
  return [
    IM360Parser.getInstance().createActivity(
      {
        title: 'Lesson Observations',
        assignment: 'participation',
        assessment_grading: 'formative',
      },
      [
        ...parseStandardsGroup(
          observation.standards,
          observation.ancillary_content,
        ),
        IM360Parser.getInstance().createNoteNode({
          title: 'Look Fors',
          value: createUnorderedList(
            observation.ancillary_content.look_fors.map(({ title }) => title),
          ),
          studentFacing: false,
        }),
      ],
    ),
  ]
}
